let callback = (a: number) => a;

export const setErrorHandlerCallback = (c: any) => {
  callback = c;
};

export const handleError = (e: number) => callback(e);
